var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import getLogoutUrl from 'root/src/client/util/getLogoutUrl';
import { buildCookie } from 'root/src/client/v2/browser/helpers/cookies';
import { useAsyncAction } from 'root/src/client/v2/common/hooks/useAsyncAction';
const AUTH_COOKIES = ['email', 'refreshToken', 'accessToken', 'userId', 'groups', 'parentUserId'];
// Shared sign-out for the redesign chrome: clears the auth cookies and navigates to the logout URL
// together (so the navbar does not flip to a logged-out state before leaving). Used by both the
// RedesignNavbar user menu and the command palette so the behaviour stays identical in one place.
export const useRedesignLogout = () => {
    const { loading, run } = useAsyncAction();
    const logout = useCallback(() => {
        run(() => __awaiter(void 0, void 0, void 0, function* () {
            yield new Promise((resolve) => { setTimeout(resolve, 600); });
        }), {
            successHold: 0,
            onSuccess: () => {
                AUTH_COOKIES.forEach((name) => {
                    document.cookie = buildCookie(name, '', -1);
                });
                window.location.href = getLogoutUrl();
            },
        });
    }, [run]);
    return { loggingOut: loading, logout };
};
